import { render } from "./PromotionTabMain.vue?vue&type=template&id=0a7861f4&scoped=true"
import script from "./PromotionTabMain.vue?vue&type=script&lang=js"
export * from "./PromotionTabMain.vue?vue&type=script&lang=js"

import "./PromotionTabMain.vue?vue&type=style&index=0&id=0a7861f4&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a7861f4"]])

export default __exports__